export const TEXT = {
  SAVE_WORKSPACE: "Save Project",
  SAVING: "Saving...",
  SAVE_AS_NEW_WORKSPACE: "Save As New Project",
  NO_CHANGES_TOOLTIP: "No changes to save",
};

// Styles for keeping primary color when disabled
export const disabledButtonStyle = {
  backgroundColor: "primary.main",
  opacity: 0.7,
  color: "white",
  "&.Mui-disabled": {
    backgroundColor: "primary.main",
    opacity: 0.5,
    color: "white",
  },
};
